module.exports = __webpack_public_path__ + "img/model_1.c08af38a.png";